import {
  Box, Grid, Skeleton, Typography,
} from '@mui/material';
import {
  Gauge,
  gaugeClasses,
} from '@mui/x-charts';
import React from 'react';
import { colors } from '../../theme';

function SurveysGraphsLoader() {
  return (
    <>
      <Box
        sx={{
          py: 2,
        }}
      >
        <Typography variant="h5" sx={{ mb: 0.5 }}><Skeleton width={400} /></Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 4,
        }}
      >
        <Skeleton variant="rounded" width={170} height={24} />
      </Box>
      <Grid container spacing={2} sx={{ py: 2 }}>
        {[0, 1, 2, 3, 4, 5].map((item) => (
          <Grid
            item
            xs={6}
            lg={4}
            key={item}
          >
            <Skeleton
              variant="rounded"
              sx={{
                width: '100%',
                height: 'auto',
                aspectRatio: '1',
              }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default SurveysGraphsLoader;
